// src/features/developers/types.ts

export type DeveloperTab = 'overview' | 'reference' | 'recipes' | 'downloads';

export type RecipeLanguage = 'curl' | 'csharp' | 'node' | 'python' | 'php';

export const RECIPE_LANGUAGES: Array<{ key: RecipeLanguage; label: string }> = [
  { key: 'curl', label: 'cURL' },
  { key: 'csharp', label: 'C#' },
  { key: 'node', label: 'Node.js' },
  { key: 'python', label: 'Python' },
  { key: 'php', label: 'PHP' },
];

/** `GET api/v1/ui/developers/info` (inside the `{ success, data }` envelope). */
export interface DeveloperInfo {
  title: string;
  version: string;
  currentEnvironment: string;
  environments: Array<{ key: string; name: string; apiBaseUrl: string }>;
  operations: number;
  canManageKeys: boolean;
}

export interface KeyProperty {
  id: string;
  name: string | null;
}

/** A key as the staff list shows it. The secret and its hash are never listed. */
export interface AccessKey {
  id: string;
  name: string;
  ownerName: string;
  ownerOrganizationId: string | null;
  properties: KeyProperty[];
  prefix: string;
  createdBy: string;
  createdAtUtc: string;
  lastUsedAtUtc: string | null;
  revokedAtUtc: string | null;
  status: 'active' | 'revoked';
}

/** The answer to creating a key: the only moment the secret travels. */
export interface CreatedAccessKey extends AccessKey {
  apiKey: string;
}

export interface CreateKeyRequest {
  name: string;
  ownerName: string;
  ownerOrganizationId: string | null;
  propertyIds: string[];
}
